import type { App } from 'vue'
import {
  Button,
  Popup,
  Picker,
  Guide,
  Loading,
  Image,
  Message,
  Toast,
  ImageViewer,
  Calendar,
} from 'tdesign-mobile-vue'

export default function useTDesign(app: App) {
  app
    .use(Button)
    .use(Popup)
    .use(Picker)
    .use(Guide)
    .use(Loading)
    .use(Image)
    .use(Message)
    .use(Toast)
    .use(ImageViewer)
    .use(Calendar)
}
